import type { ListPersonasOptions, Persona, PersonaListResponse } from "@shopify-harness/sdk";
import { queryOptions } from "@tanstack/react-query";

const PERSONAS_PREVIEW_LIMIT = 100;

export interface PersonasApi {
  list: (options?: ListPersonasOptions) => Promise<PersonaListResponse>;
  get: (personaId: string, options?: { signal?: AbortSignal }) => Promise<Persona>;
}

export const personaQueryKeys = {
  all: ["personas"] as const,
  list: (limit: number) => [...personaQueryKeys.all, "list", { limit }] as const,
  detail: (personaId: string) => [...personaQueryKeys.all, "detail", personaId] as const
};

export function personasQueryOptions(api: PersonasApi) {
  return queryOptions({
    queryKey: personaQueryKeys.list(PERSONAS_PREVIEW_LIMIT),
    queryFn: ({ signal }) => api.list({ limit: PERSONAS_PREVIEW_LIMIT, signal }),
    staleTime: 30_000
  });
}

export function personaQueryOptions(api: PersonasApi, personaId: string) {
  return queryOptions({
    queryKey: personaQueryKeys.detail(personaId),
    queryFn: ({ signal }) => api.get(personaId, { signal }),
    staleTime: 30_000
  });
}
